var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        { attrs: { disabled: _vm.formDisabled } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["emp.apptype.entrance"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "entranceId"
                          }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: {
                                disabled:
                                  this.$store.getters.applicationCode !=
                                  "emp_platform",
                                placeholder:
                                  _vm.language["common.pleaseChoose"] +
                                  _vm.language["emp.col.entrance.entranceName"],
                                allowClear: ""
                              },
                              on: { change: _vm.entranceChange },
                              model: {
                                value: _vm.model.entranceId,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "entranceId", $$v)
                                },
                                expression: "model.entranceId"
                              }
                            },
                            _vm._l(_vm.entrances, function(item, index) {
                              return _c(
                                "a-select-option",
                                {
                                  key: index.toString(),
                                  attrs: { value: item.id }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(item.entranceName) +
                                      "\n                "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["emp.apptype.apptypeCode"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "appTypeCode"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["emp.apptype.apptypeCode"],
                              maxLength: "35",
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.appTypeCode,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "appTypeCode", $$v)
                              },
                              expression: "model.appTypeCode"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["emp.apptype.apptypeName"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "appTypeName"
                          }
                        },
                        [
                          _c("a-input", {
                            staticStyle: { width: "85%" },
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["emp.apptype.apptypeName"],
                              maxLength: "50",
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.appTypeName,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "appTypeName", $$v)
                              },
                              expression: "model.appTypeName"
                            }
                          }),
                          _c(
                            "a-button",
                            {
                              staticStyle: { left: "3%" },
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.languageModelOpen(
                                    "emp_base_apptype",
                                    "app_type_name",
                                    _vm.apptypeLanguages
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.language["common.language"]))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["ad.image"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "imgPath"
                          }
                        },
                        [
                          _c("j-image-upload", {
                            attrs: {
                              text: this.language["common.uploadButton"],
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.imgPath,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "imgPath", $$v)
                              },
                              expression: "model.imgPath"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["emp.apptype.status"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "publishStatus"
                          }
                        },
                        [
                          _c("j-dict-select-tag", {
                            attrs: {
                              type: "radio",
                              "trigger-change": true,
                              dictCode: "sys_portal_up_down",
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.publishStatus,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "publishStatus", $$v)
                              },
                              expression: "model.publishStatus"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["emp.apptype.sort"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "sortNo"
                          }
                        },
                        [
                          _c("a-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["emp.apptype.sort"],
                              min: 1,
                              max: 999999,
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.sortNo,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "sortNo", $$v)
                              },
                              expression: "model.sortNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["basedata.remark"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "remark"
                          }
                        },
                        [
                          _c("a-textarea", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["basedata.remark"],
                              maxLength: _vm.ml,
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.remark,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "remark", $$v)
                              },
                              expression: "model.remark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["portal.unitApp"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "selectedApps"
                          }
                        },
                        [
                          _c("j-multi-select-tag", {
                            attrs: {
                              maxTagCount: 20,
                              options: _vm.appsOptions,
                              placeholder:
                                _vm.language["common.pleaseChoose"] +
                                _vm.language["portal.unitApp"],
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.selectedApps,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "selectedApps", $$v)
                              },
                              expression: "model.selectedApps"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("language-model", {
            ref: "languageModel",
            on: { ok: _vm.languageOk }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }